import { ButtonProps, Button, Center } from "@chakra-ui/react";
import { FC } from "react";
import ShiIcon from "src/atoms/ShiIcon";

const CarouselArrow: FC<ButtonProps & { light?: boolean, useAlternateDesign?: boolean, shouldHideIfDisabled?: boolean }> = ({
  light,
  useAlternateDesign = false,
  shouldHideIfDisabled = false,
  ...props
}) => {

  if (useAlternateDesign) {
    const disabledProps = shouldHideIfDisabled ? {
      display: "none"
    } : {
      opacity: 0.2
    };

    return (
      <Button
        {...props}
        variant="ghost"
        padding="0"
        _disabled={disabledProps}
      >
        <Center
          bgColor="white"
          fontSize="14px"
          lineHeight="18px"
          minHeight="50px"
          maxHeight="50px"
          minWidth="50px"
          maxWidth="50px"
          border="1px"
          borderRadius="25px"
        >
          <ShiIcon
            name="chevron"
            // transform={{ base: "scale(1)", md: "scale(1.5)"}}
            transform={"rotate(-90deg)"}
          />
        </Center>
      </Button>
    );
  }

  return (
    <Button
      bg={light ? "btn-green-bg" : "btn-nav-dark-bg"}
      color={light ? "btn-green-text" : "btn-nav-dark-text"}
      _hover={
        props.disabled
          ? {}
          : {
            bg: light ? "btn-green-hover" : "btn-nav-dark-bg-hover",
            color: light ? "white" : "btn-nav-dark-text"
          }
      }
      _disabled={{
        opacity: "0.5",
        cursor: "default",
        backgroundColor: "btn-nav-dark-bg",
        color: "btn-nav-dark-text",
      }}
      paddingY="11px"
      borderRadius="full"
      {...props}
    >
      →
    </Button>
  );
};

export default CarouselArrow;
